//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import { login,campaignInfoLogin } from '../../service/index'
import { getCookie } from '@/utils/storage'
let Base64 = require('js-base64').Base64;

export default {
  name: "Login",
  data() {
    return {
      campaign:{},
      loginForm: {
        userName: "",
        passWord: ""
      },
    };
  },
  mounted() {
    this.keepLang()
    if(typeof this.$route.query.cid ==="undefined" || this.$route.query.cid<=0){
        location.href="/is/auth/login/-1";
        return;
    }
    this.getCampaignInfo();

  },
  computed: {
    ...mapState(["global"])
  },
  methods: {
    ...mapMutations({
        setTempName: 'SET_TEMPNAME'
    }),
    async getCampaignInfo(){
        const res = await campaignInfoLogin(this.$route.query.cid);
        this.campaign=res.data;
    },
    async doLogin(){
      if(this.loginForm.userName==='' || this.loginForm.userName===''){
        this.$message({
          message: "请填写用户名密码! Please input username and password!",
          type: 'error'
        })
        return;
      }
      const param = {
        account: this.loginForm.userName, //yimlink.defia',
        password: this.loginForm.passWord,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)',
        customClass:'fullscree-loading'
      });
      const res = await login(this.$route.query.cid,param);
      loading.close();
      if(res.status === 0){
        this.setTempName(Base64.decode(getCookie("user_name")))
        this.$router.push({path:'home/'+this.$route.query.cid,query: {cid: this.$route.query.cid}})
      }else{
        this.$message({
            message: "User Password Error! 用户名密码错误!",
          type: 'error'
        })
      }
    },
    // 中英文切换事件
    switchLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh';
        localStorage.locale='zh';
      } else {
        this.$i18n.locale = 'en';
        localStorage.locale='en';
      }
    },
    // 刷新页面保存语言
    keepLang(){
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/Login.vue